export default "__VITE_ASSET__SkDWWrAT__"